import { getStatus } from 'conversations-async-data/async-data/operators/getters';
import { CLOSING_THREAD, OPENING_THREAD } from '../constants/asyncStatuses';
// @ts-expect-error module not typed

export const isOpening = asyncData =>
// @ts-expect-error we are currently misusing the AsyncData status for opening / closing threads, so this is possible in reality even if not reflected in typescript
getStatus(asyncData) === OPENING_THREAD;
export const isClosing = asyncData =>
// @ts-expect-error we are currently misusing the AsyncData status for opening / closing threads, so this is possible in reality even if not reflected in typescript
getStatus(asyncData) === CLOSING_THREAD;